import type { Suggestion } from './types';

import { CITIES, MACROREGIONS, STATE_CODES, STATES } from '~/config/cities';

import { MacroregionIdentifier } from './types';

/**
 * Get macroregions list with availability based on feature flags
 */
export function getMacroregions(): Suggestion[] {
	return [
		{
			result: {
				title: CITIES.SAO_PAULO.name,
				subtitle: STATES.SAO_PAULO
			},
			searchType: 'macroregion',
			id: MacroregionIdentifier.SAO_PAULO,
			searchParams: {
				macroregions: [],
				regions: [],
				cities: [CITIES.SAO_PAULO.name],
				states: [STATE_CODES.SAO_PAULO],
				placeId: null,
				condoSlug: null
			},
			macroregionUsed: MACROREGIONS.SAO_PAULO
		},
		{
			result: {
				title: CITIES.CURITIBA.name,
				subtitle: STATES.PARANA
			},
			searchType: 'macroregion',
			id: MacroregionIdentifier.CURITIBA,
			searchParams: {
				macroregions: [MACROREGIONS.CURITIBA],
				regions: [],
				cities: [],
				states: [STATE_CODES.PARANA],
				placeId: null,
				condoSlug: null
			},
			available: true,
			macroregionUsed: MACROREGIONS.CURITIBA
		},
		{
			result: {
				title: MACROREGIONS.ALPHAVILLE,
				subtitle: STATES.SAO_PAULO
			},
			searchType: 'macroregion',
			id: MacroregionIdentifier.ALPHAVILLE,
			searchParams: {
				macroregions: [MACROREGIONS.ALPHAVILLE],
				regions: [],
				cities: [],
				states: [STATE_CODES.SAO_PAULO],
				placeId: null,
				condoSlug: null
			},
			macroregionUsed: MACROREGIONS.ALPHAVILLE
		},
		{
			result: {
				title: MACROREGIONS.INTERIOR,
				subtitle: STATES.SAO_PAULO
			},
			searchType: 'macroregion',
			id: MacroregionIdentifier.INTERIOR,
			searchParams: {
				macroregions: [MACROREGIONS.INTERIOR],
				regions: [],
				cities: [],
				states: [STATE_CODES.SAO_PAULO],
				placeId: null,
				condoSlug: null
			},
			macroregionUsed: MACROREGIONS.INTERIOR
		},
		{
			result: {
				title: MACROREGIONS.LITORAL_NORTE,
				subtitle: STATES.SAO_PAULO
			},
			searchType: 'macroregion',
			id: MacroregionIdentifier.LITORAL_NORTE,
			searchParams: {
				macroregions: [MACROREGIONS.LITORAL_NORTE],
				regions: [],
				cities: [],
				states: [STATE_CODES.SAO_PAULO],
				placeId: null,
				condoSlug: null
			},
			macroregionUsed: MACROREGIONS.LITORAL_NORTE
		},
		{
			result: {
				title: MACROREGIONS.LITORAL_SUL,
				subtitle: STATES.SAO_PAULO
			},
			searchType: 'macroregion',
			id: MacroregionIdentifier.LITORAL_SUL,
			searchParams: {
				macroregions: [MACROREGIONS.LITORAL_SUL],
				regions: [],
				cities: [],
				states: [STATE_CODES.SAO_PAULO],
				placeId: null,
				condoSlug: null
			},
			macroregionUsed: MACROREGIONS.LITORAL_SUL
		}
	];
}

// Placeholders centralizados
export const SEARCH_PLACEHOLDERS = {
	primary: 'Onde você gostaria de morar?',
	focused: 'Inicie sua busca',
	animated: [
		'Onde você gostaria de morar?',
		'Busque por bairro',
		'Busque por rua',
		'Busque por endereço completo',
		'Busque por ponto de interesse',
		'Busque por condomínio'
	],
	dialog: 'Endereço, bairro, cidade, condomínio e código do imóvel'
} as const;
